import React from 'react';
import { XCircle, ArrowLeft, ShoppingCart } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const CreditCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-rose-400 via-pink-500 to-purple-600 flex items-center justify-center">
      <div className="max-w-md mx-auto px-4">
        <div className="bg-white/10 backdrop-blur-md rounded-2xl p-8 text-center">
          {/* Cancel Icon */}
          <div className="mx-auto w-20 h-20 bg-orange-500 rounded-full flex items-center justify-center mb-6">
            <XCircle className="w-12 h-12 text-white" />
          </div>

          {/* Cancel Message */}
          <h1 className="text-3xl font-bold text-white mb-4">
            Purchase Cancelled
          </h1>
          
          <p className="text-white/80 mb-8">
            No charges were made to your account. You can always purchase credits later to unlock premium features.
          </p>

          {/* Action Buttons */}
          <div className="space-y-4">
            <button
              onClick={() => navigate('/credits')}
              className="w-full bg-rose-600 hover:bg-rose-700 text-white font-semibold py-3 px-6 rounded-xl transition-colors flex items-center justify-center space-x-2"
            >
              <ShoppingCart className="w-5 h-5" />
              <span>Try Again</span>
            </button>

            <button
              onClick={() => navigate('/')}
              className="w-full bg-white/10 hover:bg-white/20 text-white py-3 px-6 rounded-xl transition-colors flex items-center justify-center space-x-2"
            >
              <ArrowLeft className="w-5 h-5" />
              <span>Return to Home</span>
            </button>
          </div>

          {/* Help Text */}
          <div className="mt-8 p-4 bg-white/10 rounded-xl">
            <p className="text-white/70 text-sm">
              💡 Having trouble with payments? Contact our support team for assistance.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreditCancel;